import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import { useCmsApiPageHomePageMeta } from './useCmsApiPageHomePageMeta';

type Props = {
  cmsApiPage: CmsApiPage;
};

export function useCmsApiPageHasPostSearchToolbar({ cmsApiPage }: Props) {
  const { subsiteHasHomePage } = useCmsApiPageHomePageMeta({ cmsApiPage });

  // Search bar at the top of page only should appear on "content pages"
  return subsiteHasHomePage && cmsApiPage.hasSearch;
}
